import { inject } from '@angular/core';
import { IPaymentPreference } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { IGetGateway, ISaveGateway } from '../../gateways';

export class PaymentPreferenceGateway
  implements
    IGetGateway<string, IApiResponse<IPaymentPreference>>,
    ISaveGateway<IPaymentPreference, IApiResponse<IPaymentPreference>>
{
  private readonly configService: AppConfigService = inject(AppConfigService);

  private readonly restCallBuilder: RestCallBuilder<any> =
    new RestCallBuilder<IPaymentPreference>({
      userId: '',
      paymentMethodId: '',
      paymentProvider: '',
    });

  get(query: string): Observable<IApiResponse<IPaymentPreference>> {
    return this.restCallBuilder
      .getExternal(
        `${this.configService.get().general.userServiceUrl}/payment-preference?userId=${query}`
      )
      .handleMessages()
      .build();
  }

  save(
    query: IPaymentPreference
  ): Observable<IApiResponse<IPaymentPreference>> {
    return this.restCallBuilder
      .postExternal(
        `${this.configService.get().general.userServiceUrl}/payment-preference/save`,
        query
      )
      .handleMessages()
      .build();
  }
}
